/*
  Keeps the fit guide in step with the RAEN grouped colour picker.

  A swatch that belongs to a sibling colourway carries data-product-url, and
  VariantSelects.switchProduct() re-renders #shopify-section-{main-product} for that
  product. sections/pdp-fit-guide.liquid is a separate section on the template and is
  driven entirely by product metafields (lens width, frame measurement, lens
  category), so it is left describing the colourway the visitor has just navigated
  away from. This re-renders it through the same Section Rendering API call.

  Only the fit guide is refreshed, which is what the live 3.0.1 build did too. Other
  product-dependent sections on the template — recommendations, custom Liquid — stay
  as first rendered. That holds only within one template, so a swatch for a product
  on a different template does a full page load instead (see below).

  Self-contained and idempotent: it binds one delegated listener on document, so it
  survives the section swap and is not re-bound when the replaced markup brings the
  script tag back (browsers do not execute <script src> inserted via innerHTML).
*/
(function () {
  if (window.__raenSwatchFitGuide) return;
  window.__raenSwatchFitGuide = true;

  var controller = null;

  function fitGuideSectionId() {
    var root = document.querySelector('[data-current-handle]');
    if (!root) return null;
    var section = root.closest('.shopify-section');
    if (!section || !section.id) return null;
    return section.id.replace(/^shopify-section-/, '');
  }

  function handleFromUrl(url) {
    return url.split('?')[0].split('#')[0].replace(/\/+$/, '').split('/').pop();
  }

  function refresh(productUrl) {
    var root = document.querySelector('[data-current-handle]');
    if (!root) return;
    if (root.dataset.currentHandle === handleFromUrl(productUrl)) return;

    var sectionId = fitGuideSectionId();
    if (!sectionId) return;

    // A quick run along the swatches queues several of these; the slowest response
    // would otherwise win and describe the wrong colourway.
    if (controller) controller.abort();
    controller = new AbortController();

    fetch(productUrl + '?section_id=' + encodeURIComponent(sectionId), { signal: controller.signal })
      .then(function (response) {
        if (!response.ok) throw new Error('Fit guide fetch failed: ' + response.status);
        return response.text();
      })
      .then(function (text) {
        var incoming = new DOMParser()
          .parseFromString(text, 'text/html')
          .getElementById('shopify-section-' + sectionId);
        var current = document.getElementById('shopify-section-' + sectionId);
        if (incoming && current) current.innerHTML = incoming.innerHTML;
      })
      .catch(function (error) {
        if (error.name !== 'AbortError') console.error(error);
      });
  }

  // A swatch flagged data-full-reload belongs to a colourway on another template
  // (Wiley ↔ Wiley REC). Swapping only the product section would leave the old
  // product's description, video and reviews below it, so load the page instead.
  // Capture phase on document runs before VariantSelects' own listener.
  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || target.type !== 'radio' || !target.closest || !target.closest('variant-selects')) return;
    if (!target.hasAttribute('data-full-reload') || !target.dataset.productUrl) return;

    event.stopImmediatePropagation();
    window.location.assign(target.dataset.productUrl);
  }, true);

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || !target.closest || !target.closest('variant-selects')) return;

    var productUrl = null;
    if (target.tagName === 'SELECT') {
      var selected = target.selectedOptions[0];
      productUrl = selected && selected.dataset.productUrl;
    } else if (target.type === 'radio') {
      productUrl = target.dataset.productUrl;
    }

    if (productUrl) refresh(productUrl);
  });
})();
